import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DeepLinksState, DeepLinksReferral } from "./types";

const initialState: DeepLinksState = {
  referral: null,
};

export const deepLinksSlice = createSlice({
  name: "deepLinks",
  initialState,
  reducers: {
    setReferral: (state, action: PayloadAction<DeepLinksReferral | null>) => {
      state.referral = action.payload;
      state.error = null;
    },
    clearReferral: (state) => {
      state.referral = null;
      state.error = null;
    },
  },
});

export const { setReferral, clearReferral } = deepLinksSlice.actions;
